import React from "react";

import styles from "./Header.module.css";

const Header = () => {
  return (
    <header className={styles.header}>
      <nav className={styles.socials}>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.instagram.com/iconicminds_pt"
        >
          <img
            src="/images/instagram.svg"
            alt="Instagram"
            width={20}
            height={20}
            className={styles.icon}
          />
        </a>
        <a href="mailto:info@iconicminds.pt">
          <img
            src="/images/email.svg"
            alt="email"
            width={20}
            height={20}
            className={styles.icon}
          />
        </a>
      </nav>
    </header>
  );
};

export default Header;
